<template>
  <div>
    <div class="mt-9 membership_manage_setting">
      <p class="mb-3 title font-weight-bold">
        멤버십 상품/혜택 설정
      </p>
      <v-card width="1108" outlined class="pt-0">
        <div class="d-flex">
          <v-card-text
            class="pa-0 d-flex align-center"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-0 ml-5 font-weight-medium black--text"
              >
                멤버십명
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0" style="max-width:334px;">
            <div class="float-left ml-5">
              <v-text-field
                v-model="membership_name"
                outlined
                class="mt-2 mb-2"
                hide-details
                dense
                style="width:295px;"
              ></v-text-field>
            </div>
          </v-card-text>
          <v-card-text
            class="pa-0 d-flex align-center"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-0 ml-5 font-weight-medium black--text"
              >
                멤버십 판매가격
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0" style="max-width:334px;">
            <div class="float-left ml-5 d-flex align-center">
              <v-text-field
                v-model="membership_price"
                outlined
                class="mt-2 mb-2 float-left"
                hide-details
                dense
                style="width:100px;"
                @keydown="M.replaceCommaNumber($event, 15, true)"
                @keyup="M.replaceCommaNumber($event, 15, true)"
              ></v-text-field>
              <p class="mb-0 float-left ml-1" style="font-size: 1rem;">원</p>
            </div>
          </v-card-text>
        </div>
        <v-divider></v-divider>
        <div class="d-flex">
          <v-card-text
            class="pa-0 d-flex align-center"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-0 ml-5 font-weight-medium black--text"
              >
                결제 설정
              </p>
            </div>
            <div class="float-left">
              <template>
                <div
                  class="text-center d-flex align-center justify-space-around"
                >
                  <div>
                    <v-tooltip
                      v-model="tooltip_show"
                      bottom
                      content-class="tooltip_show"
                    >
                      <template v-slot:activator="{ attrs }">
                        <v-icon
                          v-bind="attrs"
                          class="ml-2"
                          @click="tooltip_show = !tooltip_show"
                          color="#8C8C8C"
                          >mdi-alert-circle</v-icon
                        >
                      </template>
                      <div>
                        <p class="text-left">
                          멤버십 상품 결제 설정에 참고해주세요.
                        </p>
                        <p class="text-left mb-0">
                          1. 정기결제는 PG사의 '정기배송(결제)&예약 결제' 승인
                          완료 후 사용해주셔야 합니다.
                        </p>
                        <p class="text-left mb-0">
                          2. 멤버십 상품을 만드신 후에는 결제 타입 수정이
                          불가합니다.
                        </p>
                        <p class="text-left mb-0">
                          3. 결제 타입을 변경하실 경우에는 삭제 후 새로운 멤버십
                          상품을 만들어 사용합니다.
                        </p>
                        <p class="text-left mb-0">
                          4. '1달 무료 체험'과 같이 무료 기간 혜택 후 자동
                          결제를 받으시려면 정기결제 설정을 하셔야 사용이
                          가능합니다.
                        </p>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
          <v-card-text
            style="max-width:334px;  height:56px;"
            class="pa-0 d-flex align-center"
          >
            <div class="float-left pa-0 ml-5">
              <v-container
                fluid
                class="pa-0 float-left"
                style="max-width:240px;"
              >
                <v-radio-group
                  row
                  hide-details
                  v-model="periodic_payment_model"
                  dense
                  class="mt-0"
                  :disabled="true"
                >
                  <v-radio
                    value="enabled"
                    class="mb-0"
                    :disabled="periodic_payment_disabled"
                  >
                    <template v-slot:label>
                      <p
                        :class="{
                          'mb-0': true,
                          'mr-3': true,
                          'black--text ': !periodic_payment_disabled,
                        }"
                      >
                        정기결제
                      </p>
                    </template>
                  </v-radio>
                  <v-radio
                    value="disabled"
                    class="mb-0"
                    :disabled="one_payment_disabled"
                  >
                    <template v-slot:label>
                      <p
                        class="mb-0"
                        :class="{
                          'mb-0': true,
                          'black--text ': !one_payment_disabled,
                        }"
                      >
                        1회결제
                      </p>
                    </template>
                  </v-radio>
                </v-radio-group>
              </v-container>
            </div>
          </v-card-text>
          <v-card-text
            class="pa-0 d-flex align-center"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-0 ml-5 font-weight-medium black--text"
              >
                멤버십 혜택 기간
              </p>
            </div>
          </v-card-text>
          <v-card-text
            class="pa-0 ml-5 d-inline-flex align-center"
            style="max-width:220px;"
          >
            <div class="float-left d-inline-flex align-center">
              <div>
                <v-select
                  v-model="benefitPeriodModel"
                  :items="benefitPeriodItems"
                  item-text="text"
                  item-value="value"
                  persistent-hint
                  single-line
                  class="mr-2 mt-2 mb-2"
                  outlined
                  dense
                  hide-details
                  style="max-width:240px;"
                ></v-select>
              </div>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0 d-flex align-center"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-0 ml-5 font-weight-medium black--text"
              >
                첫 구매 무료 혜택
              </p>
            </div>
          </v-card-text>
          <v-card-text
            class="pa-0 ml-5 d-inline-flex align-center"
            style="max-width:720px;"
          >
            <div class="float-left d-inline-flex align-center">
              <div>
                <v-select
                  :disabled="use_free_term_disabled"
                  v-model="use_free_term"
                  :items="use_free_term_items"
                  item-text="text"
                  item-value="value"
                  persistent-hint
                  single-line
                  class="mr-2 mt-2 mb-2"
                  outlined
                  dense
                  hide-details
                  style="max-width:240px;"
                  @change="useFreeStartChange()"
                ></v-select>
              </div>

              <div class="d-flex align-center ml-5" style="width: 650px;">
                <p class="mb-0">
                  정기결제만 사용 가능 - 선택한 기간을 무료 혜택 지급 후 자동
                  정기결제 되도록 합니다.
                  <br />
                  (사용안함을 선택하는 경우 카페24 사양에 따라 1일 후 정기결제
                  처리가 됩니다.)
                </p>
              </div>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-0 mt-5 ml-5 font-weight-medium black--text"
              >
                멤버십 회원등급 설정
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5">
            <div class="float-left">
              <p class="mb-0 float-left mt-5">
                <a
                  class="hover-text-decoration-underline"
                  :href="cafe24_group_url"
                  target="_blank"
                  ><font class="primary--text"
                    >[ 카페24 어드민 > 고객관리 > 회원관리 > 회원등급관리
                    ]</font
                  ></a
                >
                메뉴에서 '등급추가'하여 해당 멤버십 등급을 만들어주세요.
              </p>
              <p class="mb-0 float-left mt-0">
                <font class="purple--text"
                  >할인/적립, 배송비 무료 혜택을 설정</font
                >하신 후 해당 등급을 조회하여 매칭합니다.
              </p>
            </div>
            <div>
              <v-btn
                depressed
                small
                color="#2196f3"
                class="font-weight-black mr-0 white--text mt-3"
                aling="left"
                @click="memberLeveSearchMatching()"
                >회원등급 조회/매칭하기</v-btn
              >
            </div>

            <!---->
            <div>
              <v-card width="846" outlined class="pt-0 d-flex mt-3 mr-5  mb-5">
                <v-card-text class="pa-0">
                  <div style="display:flow-root;">
                    <div class="float-left">
                      <p
                        v-if="group_no"
                        class="pt2 mb-3 mt-3 ml-5 font-weight-medium membershipCardTextSize black--text"
                      >
                        <font class="primary--text font-weight-bold mr-1">{{
                          group_name
                        }}</font>
                        회원등급 매칭되었습니다.
                      </p>
                      <p
                        v-else
                        class="pt2 mb-3 mt-3 ml-5 font-weight-medium greyColor membershipCardTextSize"
                      >
                        - 멤버십에 매칭된 회원등급이 없습니다.
                      </p>
                    </div>

                    <div v-if="group_no" class="float-right">
                      <v-btn
                        depressed
                        small
                        color="#7d7d7d"
                        class="font-weight-black white--text float-right mr-5 mt-3 mb-3"
                        aling="left"
                        @click="memberLevelClose(group_no)"
                        >매칭 해지</v-btn
                      >
                    </div>
                  </div>

                  <div>
                    <v-card
                      width="157"
                      outlined
                      class="pt-0 d-flex mb-5 ml-5 mr-0 float-left"
                    >
                      <v-card-text class="pa-0">
                        <div class="text-center">
                          <p
                            class="pt2 mt-3 subtitle-2"
                            style="color: rgba(0, 0, 0, 0.6);"
                          >
                            무료 배송
                          </p>
                          <p
                            v-if="ship_benefits == 'T'"
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            제공
                          </p>
                          <p
                            v-else
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            -
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      width="157"
                      outlined
                      class="pt-0 d-flex mb-5 ml-1 mr-0 float-left"
                    >
                      <v-card-text class="pa-0">
                        <div class="text-center">
                          <p
                            class="pt2 mt-3 subtitle-2"
                            style="color: rgba(0, 0, 0, 0.6);"
                          >
                            구매시 할인
                          </p>
                          <p
                            v-if="
                              discount_information.amount_discount > 0 &&
                                discount_information.discount_unit == 'P'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ discount_information.amount_discount }}%
                          </p>
                          <p
                            v-else-if="
                              discount_information.amount_discount > 0 &&
                                discount_information.discount_unit == 'W'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ discount_information.amount_discount | comma }}원
                          </p>
                          <p
                            v-else
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            -
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      width="157"
                      outlined
                      class="pt-0 d-flex mb-5 ml-1 mr-0 float-left"
                    >
                      <v-card-text class="pa-0">
                        <div class="text-center">
                          <p
                            class="pt2 mt-3 subtitle-2"
                            style="color: rgba(0, 0, 0, 0.6);"
                          >
                            구매시 적립
                          </p>
                          <p
                            v-if="
                              points_information.amount_discount > 0 &&
                                points_information.discount_unit == 'P'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ points_information.amount_discount }}%
                          </p>
                          <p
                            v-else-if="
                              points_information.amount_discount > 0 &&
                                points_information.discount_unit == 'W'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ points_information.amount_discount | comma }}원
                          </p>
                          <p
                            v-else
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            -
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      width="157"
                      outlined
                      class="pt-0 d-flex mb-5 ml-1 mr-0 float-left"
                    >
                      <v-card-text class="pa-0">
                        <div class="text-center">
                          <p
                            class="pt2 mt-3 subtitle-2"
                            style="color: rgba(0, 0, 0, 0.6);"
                          >
                            모바일 추가 할인
                          </p>

                          <p
                            v-if="
                              mobile_discount_information.amount_discount > 0 &&
                                mobile_discount_information.discount_unit == 'P'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ mobile_discount_information.amount_discount }}%
                          </p>
                          <p
                            v-else-if="
                              mobile_discount_information.amount_discount > 0 &&
                                mobile_discount_information.discount_unit == 'W'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{
                              mobile_discount_information.amount_discount
                                | comma
                            }}원
                          </p>
                          <p
                            v-else
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            -
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                    <v-card
                      width="157"
                      outlined
                      class="pt-0 d-flex mb-5 ml-1 mr-5 float-left"
                    >
                      <v-card-text class="pa-0">
                        <div class="text-center">
                          <p
                            class="pt2 mt-3 subtitle-2"
                            style="color: rgba(0, 0, 0, 0.6);"
                          >
                            모바일 추가 적립
                          </p>
                          <p
                            v-if="
                              mobile_points_information.amount_discount > 0 &&
                                mobile_points_information.discount_unit == 'P'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{ mobile_points_information.amount_discount }}%
                          </p>
                          <p
                            v-else-if="
                              mobile_points_information.amount_discount > 0 &&
                                mobile_points_information.discount_unit == 'W'
                            "
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            {{
                              mobile_points_information.amount_discount | comma
                            }}원
                          </p>
                          <p
                            v-else
                            style="font-size: 1.2rem;"
                            class="pt2 black--text"
                          >
                            -
                          </p>
                        </div>
                      </v-card-text>
                    </v-card>
                  </div>
                </v-card-text>
              </v-card>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-3 mt-5 ml-5 font-weight-medium black--text"
              >
                쿠폰 지급
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5">
            <div class="float-left">
              <p class="mb-0 float-left mt-5">
                <a
                  :href="cafe24_coupon_url"
                  target="_blank"
                  class="hover-text-decoration-underline"
                  ><font class="primary--text"
                    >[ 카페24 어드민 > 프로모션 > 쿠폰 관리 > 쿠폰 만들기
                    ]</font
                  ></a
                >
                메뉴에서 해당 멤버십 회원에게 제공할 쿠폰을 만들어주세요.
              </p>
              <p class="mb-0 float-left mt-0">
                <font class="purple--text"
                  >발급구분에 '대상자 지정 발급', 발급시점 '즉시 발급'</font
                >으로 설정하셔야 합니다.
              </p>
            </div>
            <div class="mb-0">
              <v-btn
                depressed
                small
                color="#1976d2"
                class="font-weight-black mr-0 white--text mt-3 mb-0"
                aling="left"
                @click="couponSearchSetting()"
                >+ 쿠폰 조회 및 설정</v-btn
              >
            </div>

            <div v-if="coupon_list.length == 0" class="mt-3">
              <v-card
                width="846"
                outlined
                class="pt-0 d-flex mb-0 ml-0 mr-0 float-left"
              >
                <v-card-text class="pa-0">
                  <div class="ml-5">
                    <p class="pt2 mt-3 greyColor membershipCardTextSize">
                      - 멤버십에 매칭된 쿠폰이 없습니다.
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div v-else>
              <div v-for="(coupon, index) in coupon_list" :key="index">
                <v-card
                  width="846"
                  outlined
                  class="pt-0 d-flex mb-0 ml-0 mr-0 mt-3 float-left"
                >
                  <v-card-text class="pa-0">
                    <div
                      v-if="coupon.coupon_issued_type == 'payment'"
                      class="ml-5 float-left"
                    >
                      <p class="pt2 mt-3 membershipCardTextSize black--text">
                        <font
                          class="primary--text hover hoverUnderlinPrimary font-weight-bold mr-1"
                          @click="couponClick(coupon.coupon_no)"
                          >{{ coupon_info_list[coupon.coupon_no] }} - 멤버십
                          구매시 지급</font
                        >
                        매칭되었습니다.
                      </p>
                    </div>
                    <div v-else-if="coupon.coupon_issued_type == 'subscription'" class="ml-5 float-left">
                      <p class="pt2 mt-3 membershipCardTextSize black--text">
                        <font
                          class="primary--text hover hoverUnderlinPrimary font-weight-bold mr-1"
                          @click="couponClick(coupon.coupon_no)"
                          >{{ coupon_info_list[coupon.coupon_no] }} - 매월
                          {{
                            coupon.coupon_subscription
                              | pointSubscriptionConversion
                          }}
                          지급</font
                        >매칭되었습니다.
                      </p>
                    </div>
                    <div v-else class="ml-5 float-left">
                      <p class="pt2 mt-3 membershipCardTextSize black--text">
                        <font
                          class="primary--text hover hoverUnderlinPrimary font-weight-bold mr-1"
                          @click="couponClick(coupon.coupon_no)"
                          >{{ coupon_info_list[coupon.coupon_no] }} - 2회차 멤버십 구매시</font
                        >매칭되었습니다.
                      </p>
                    </div>
                    <div class="float-right mr-5">
                      <v-btn
                        depressed
                        small
                        color="#7d7d7d"
                        class="font-weight-black mr-0 white--text mt-3 mb-0"
                        aling="right"
                        @click="couponMatchingClose(coupon.coupon_no)"
                        >매칭 해지</v-btn
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>

            <div>
              <v-checkbox
                class="mt-1 float-left mr-3 black--text mb-5"
                hide-details
                dense
                v-model="couponReclaimModel"
              >
                <template v-slot:label>
                  <div>
                    <p class="mb-0 black--text membershipCardTextSize">
                      고객이 멤버십 상품을 취소하는 경우 지급된 쿠폰을
                      회수합니다.
                    </p>
                  </div>
                </template>
              </v-checkbox>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left mt-5">
              <p
                style="font-size: 1rem;"
                class="mb-3 mt-0 ml-5 font-weight-medium black--text"
              >
                적립금 지급
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5 mt-5">
            <div class="mb-0 mt-0">
              <v-btn
                depressed
                small
                color="#1976d2"
                class="font-weight-black mr-0 white--text mt-0 mb-0"
                aling="left"
                @click="pointSetting()"
                >+ 멤버십 적립금 설정</v-btn
              >
            </div>

            <div v-if="point_list.length == 0" class="mt-3">
              <v-card
                width="846"
                outlined
                class="pt-0 d-flex mb-0 ml-0 mr-0 float-left"
              >
                <v-card-text class="pa-0">
                  <div class="ml-5">
                    <p class="pt2 mt-3 greyColor membershipCardTextSize">
                      - 멤버십에 해당하는 적립금 설정이 없습니다.
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div v-else>
              <div v-for="(point, index) in point_list" :key="index">
                <v-card
                  width="846"
                  outlined
                  class="pt-0 d-flex mb-0 ml-0 mr-0 mt-3 float-left"
                >
                  <v-card-text class="pa-0">
                    <div class="ml-5 float-left">
                      <p
                        v-if="point.point_issued_type == 'payment'"
                        class="pt2 mt-3 membershipCardTextSize black--text"
                      >
                        <font class="primary--text font-weight-bold mr-1"
                          >{{ point.point | comma }}원 - 멤버십 구매시 지급
                        </font>
                        설정되었습니다.
                      </p>
                      <p
                        v-else
                        class="pt2 mt-3 membershipCardTextSize black--text"
                      >
                        <font class="primary--text font-weight-bold mr-1"
                          >{{ point.point | comma }}원 - 다음달
                          {{
                            point.point_subscription
                              | pointSubscriptionConversion
                          }}
                          지급</font
                        >
                        설정되었습니다.
                      </p>
                    </div>
                    <div class="float-right mr-5">
                      <v-btn
                        depressed
                        small
                        color="#7d7d7d"
                        class="font-weight-black mr-0 white--text mt-3 mb-0"
                        aling="right"
                        @click="pointMatchingClose(index)"
                        >설정 해지</v-btn
                      >
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
            <div>
              <v-checkbox
                class="mt-1 float-left mr-3 black--text mb-5"
                hide-details
                dense
                v-model="pointReclaimModel"
              >
                <template v-slot:label>
                  <div>
                    <p class="mb-0 black--text membershipCardTextSize">
                      고객이 멤버십 상품을 취소하는 경우 지급된 적립금을
                      회수합니다.
                    </p>
                  </div>
                </template>
              </v-checkbox>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-3 mt-5 ml-5 font-weight-medium black--text"
              >
                멤버십 전용 상품
              </p>
            </div>
            <div class="float-left mt-5">
              <template>
                <div class="text-center float-left">
                  <div style="display: flex;">
                    <v-tooltip
                      v-model="only_member_tooltip_show"
                      bottom
                      content-class="only_member_tooltip_show"
                    >
                      <template v-slot:activator="{ attrs }">
                        <v-icon
                          v-bind="attrs"
                          class="ml-2"
                          @click="
                            only_member_tooltip_show = !only_member_tooltip_show
                          "
                          color="#8C8C8C"
                          >mdi-alert-circle</v-icon
                        >
                      </template>
                      <div>
                        <p class="text-left">
                          회원 전용 상품 설정에 참고해주세요.
                        </p>
                        <p class="text-left mb-0">
                          1. 멤버십 회원등급만 사용가능한 상품분류와 상품을
                          제공할 수 있습니다.
                        </p>
                        <p class="text-left mb-0">
                          2. 카페24 상품분류, 상품을 등록하신 후에 해당
                          상품분류를 조회하여 매칭하시면 노출등 관리가
                          가능합니다.
                        </p>
                        <p class="text-left mb-0">
                          3. 제공하려는 상품을 추가하시는 경우에 카페24
                          상품등록시 해당 상품분류를 선택하여 등록하시면 됩니다.
                        </p>
                      </div>
                    </v-tooltip>
                  </div>
                </div>
              </template>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5">
            <div class="float-left">
              <p class="mb-0 float-left mt-5 mb-0">
                <a
                  :href="cafe24_category_url"
                  target="_blank"
                  class="hover-text-decoration-underline"
                  ><font class="primary--text"
                    >[ 카페24 어드민 > 상품분류관리 > 분류관리 ]</font
                  ></a
                >
                메뉴에서 해당 멤버십 회원이 접근 가능한 상품 분류를
                만들어주세요.
              </p>
              <p class="mb-0 float-left mt-0">
                1. 상품 분류 설정시에
                <font class="purple--text"
                  >'표시상태'에 노출 체크박스를 선택</font
                >
                합니다.
              </p>
              <p class="mb-0 float-left mt-0">
                2. 상품 분류 설정시에
                <font class="purple--text"
                  >'접근권한'에 특정 회원등급만 이용가능 - 이용가능한 멤버십
                  회원등급을 선택</font
                >
                합니다
              </p>

              <p class="mb-0 float-left mt-3">
                <a
                  :href="cafe24_product_url"
                  target="_blank"
                  class="hover-text-decoration-underline"
                  ><font class="primary--text"
                    >[ 카페24 어드민 > 상품관리 > 상품등록 ]</font
                  ></a
                >
                메뉴에서 해당 멤버십 회원에게 제공할 상품을 만들어주세요.
              </p>

              <p class="mb-0 float-left mt-0">
                1.
                <font class="purple--text"
                  >상품 분류 선택 - 위에 만든 멤버십 회원 전용 상품분류만
                  추가</font
                >하여 상품을 생성합니다.
              </p>

              <p class="mb-0 float-left mt-0">
                2.
                <font class="purple--text"
                  >판매정보 '구매제한' 항목 - '회원만 구매 가능'으로 선택하고,
                  해당 멤버십 회원 등급을 선택</font
                >합니다.
              </p>
            </div>
            <div>
              <v-btn
                depressed
                small
                color="#2196f3"
                class="font-weight-black mr-0 white--text mt-3"
                aling="left"
                @click="productSearchMatching()"
                >+ 상품 분류 조회/매칭</v-btn
              >
            </div>

            <div v-if="product_list.length == 0">
              <v-card
                width="846"
                outlined
                class="pt-0 d-flex mb-5 ml-0 mr-0 mt-3 float-left"
              >
                <v-card-text class="pa-0">
                  <div>
                    <p class="pt2 mt-3 greyColor membershipCardTextSize ml-5">
                      - 해당 멤버십 전용으로 매칭된 상품 분류가 없습니다
                    </p>
                  </div>
                </v-card-text>
              </v-card>
            </div>

            <div v-else>
              <div v-for="product in product_list" :key="product.category_no">
                <v-card
                  width="846"
                  outlined
                  class="pt-0 mb-5 ml-0 mr-0 mt-3 float-left"
                  style="display:grid;"
                >
                  <v-card-text class="pa-0">
                    <div class="ml-5 float-left">
                      <p
                        class="pt2 mt-3 mb-1 membershipCardTextSize black--text"
                      >
                        <font
                          class="primary--text hover hoverUnderlinPrimary font-weight-bold mr-1"
                          @click="productClick()"
                        >
                          {{ product_info_list[product.category_no] }}</font
                        >
                        <font
                          class="primary--text font-weight-bold mr-1"
                          @click="productClick()"
                          >-</font
                        >
                        <font
                          class="primary--text hover hoverUnderlinPrimary font-weight-bold mr-1"
                          @click="productDetailClick(product.category_no)"
                          >{{ product.category_product_count }}개 상품</font
                        >
                        매칭되었습니다.
                      </p>
                    </div>
                    <div class="float-right mr-5">
                      <v-btn
                        depressed
                        small
                        color="#7d7d7d"
                        class="font-weight-black mr-0 white--text mt-3 mb-0"
                        aling="right"
                        @click="productMatchingClose(product.category_no)"
                        >매칭 해지</v-btn
                      >
                    </div>
                  </v-card-text>
                  <v-card-text class="pa-0">
                    <div class="ml-5 float-left">
                      <p class="pt2 mt-0 greyColor membershipCardTextSize">
                        http://{{
                          mall_id
                        }}.cafe24.com/product/list.html?cate_no={{
                          product.category_no
                        }}
                      </p>
                    </div>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-card-text>
        </div>

        <v-divider></v-divider>

        <div class="d-flex">
          <v-card-text
            class="pa-0"
            style="max-width:220px; background-color:#f0f7ff;"
          >
            <div class="float-left">
              <p
                style="font-size: 1rem;"
                class="mb-3 mt-5 ml-5 font-weight-medium black--text"
              >
                멤버십 해지 설정
              </p>
            </div>
          </v-card-text>
          <v-card-text class="pa-0 ml-5">
            <div class="float-left">
              <p class="mb-0 mt-5">
                [ 쇼핑몰 마이페이지 > 멤버십 관리 페이지 ]에서
                <font class="purple--text"
                  >멤버십 회원이 직접 해지 사용 여부를 설정</font
                >할 수 있습니다.
              </p>
              <p class="mb-0">
                <font class="purple--text"
                  >'멤버십 주문 목록' 메뉴에서 관리자가 직접 해지 처리는
                  가능</font
                >하오니 참고해주세요.
              </p>
              <p class="mb-0">
                고객이 멤버십 혜택을 받은 후 해지하거나 카드결제, 계좌이체외
                결제 수단인 경우 자동 환불처리가 되지 않습니다.
              </p>
              <p class="mb-0">
                운영 정책에 따라 환불이 필요한 경우 '주문상세정보' 팝업에서 직접
                환불처리하는 것을 권장합니다.
              </p>
            </div>
            <div style="width:100%" class="mb-3 float-left d-flex align-center">
              <v-select
                v-model="front_cancel_allow"
                :items="user_memebership_cancel_items"
                item-text="text"
                item-value="value"
                persistent-hint
                single-line
                class="mr-2 mt-2 mb-2"
                outlined
                dense
                hide-details
                style="max-width:340px;"
                @change="userMemebershipCancelChange()"
                :disabled="true"
              ></v-select>
              <div class="align-center ml-5 float-left">
                <p class="mb-0 mr-3 caption">
                  멤버십 가입 후 14일 까지 해지 가능 (혜택 미사용시 즉시 해지)
                </p>
                <p class="mb-0 mr-3 caption">
                  만료 일자 1개월 전부터 해지 가능 (만료 일자 기준으로 해지)
                </p>
              </div>
              <div
                v-if="front_cancel_allow_show"
                class="d-flex align-center ml-5 float-left"
                style="width: 450px;"
              >
                <p class="mb-0 mr-3">
                  멤버십 가입 후
                </p>

                <v-text-field
                  v-model="front_cancel_within"
                  hide-details
                  outlined
                  dense
                  @keydown="M.replaceNumber($event, 15, true)"
                  @keyup="M.replaceNumber($event, 15, true)"
                  style="width:80px; max-width:80px;"
                ></v-text-field>
                <p class="mb-0 ml-3">
                  일 까지 해지 가능
                </p>
              </div>
            </div>
          </v-card-text>
        </div>

        <div class="mt-8 mb-8 d-flex float-right">
          <v-btn
            color="primary"
            width="250"
            depressed
            @click="membershipSettingSave()"
            >저장합니다.</v-btn
          >
        </div>
      </v-card>
    </div>
    <MemberLevelSearchMatching
      ref="MemberLevelSearchMatching"
    ></MemberLevelSearchMatching>
    <CouponSearchSetting ref="CouponSearchSetting"></CouponSearchSetting>
    <PointSetting ref="PointSetting"></PointSetting>
    <ProductSearchMatching ref="ProductSearchMatching"></ProductSearchMatching>
    <ProgressDialog ref="ProgressDialog"></ProgressDialog>
  </div>
</template>

<style scoped>
.tooltip_show {
  left: 350px !important;
  position: absolute;
}
.only_member_tooltip_show {
  left: 350px !important;
  position: absolute;
}
</style>

<script>
import CommonMixin from "@/mixins/CommonMixin.js";
import M from "@/libs/mapping.js";
import Filters from "@/libs/membership/filters.js";
import Common from "@/libs/common.js";

const MemberLevelSearchMatching = () =>
  import(
    /* webpackChunkName: "MemberLevelSearchMatching" */ "@/components/membership/membership_manage/modal/MemberLevelSearchMatching.vue"
  );
const CouponSearchSetting = () =>
  import(
    /* webpackChunkName: "CouponSearchSetting" */ "@/components/membership/membership_manage/modal/CouponSearchSetting.vue"
  );
const ProductSearchMatching = () =>
  import(
    /* webpackChunkName: "ProductSearchMatching" */ "@/components/membership/membership_manage/modal/ProductSearchMatching.vue"
  );
const ProgressDialog = () =>
  import(
    /* webpackChunkName: "ProgressDialog" */ "@/components/membership/membership_manage/modal/ProgressDialog.vue"
  );
const PointSetting = () =>
  import(
    /* webpackChunkName: "PointSetting" */ "@/components/membership/membership_manage/modal/PointSetting.vue"
  );

export default {
  data: () => ({
    M,
    membership_id: 0,
    couponReclaimModel: true,
    pointReclaimModel: true,
    benefitPeriodModel: "",
    benefitPeriodItems: [
      { text: "구매 후 1주", value: "1W" },
      { text: "구매 후 2주", value: "2W" },
      { text: "구매 후 3주", value: "3W" },
      { text: "구매 후 1달", value: "1M" },
      { text: "구매 후 2달", value: "2M" },
      { text: "구매 후 3달", value: "3M" },
      { text: "구매 후 4달", value: "4M" },
      { text: "구매 후 5달", value: "5M" },
      { text: "구매 후 6달", value: "6M" },
      { text: "구매 후 1년", value: "1Y" },
    ],
    use_free_term: "",
    use_free_term_items: [
      { text: "사용안함", value: "" },
      { text: "1주", value: "1W" },
      { text: "2주", value: "2W" },
      { text: "3주", value: "3W" },
      { text: "1달", value: "1M" },
      { text: "2달", value: "2M" },
      { text: "3달", value: "3M" },
      { text: "4달", value: "4M" },
      { text: "5달", value: "5M" },
      { text: "6달", value: "6M" },
      { text: "1년", value: "1Y" },
    ],
    use_free_term_disabled: true,
    periodic_payment_model: "disabled",
    membership_name: "",
    membership_price: 0,
    group_no: "",
    group_name: "",
    ship_benefits: "",
    discount_information: {
      amount_product: "",
      amount_discount: "",
      discount_unit: "",
    },
    mobile_discount_information: {
      amount_product: "",
      amount_discount: "",
      discount_unit: "",
    },
    points_information: {
      amount_product: "",
      amount_discount: "",
      discount_unit: "",
    },
    mobile_points_information: {
      amount_product: "",
      amount_discount: "",
      discount_unit: "",
    },

    coupon_list: [],
    point_list: [],
    product_list: [],
    cafe24_group_url: "",
    cafe24_coupon_url: "",
    cafe24_category_url: "",
    cafe24_product_url: "",
    membership_category_url: "",
    mall_id: "",
    coupon_info_list: [],
    product_info_list: [],
    product_matching_close_list: [],
    original_product_list: [],
    periodic_payment_disabled: false,
    one_payment_disabled: false,
    tooltip_show: false,
    only_member_tooltip_show: false,
    use_free_start: null,
    user_memebership_cancel_items: [
      {
        text: "고객이 쇼핑몰에서 멤버십 해지 가능",
        value: "allowed",
      },
      {
        text: "고객이 쇼핑몰에서 멤버십 해지 불가",
        value: "disallowed",
      },
      {
        text: "멤버십 해지 유효기간 설정",
        value: "allowed_days",
      },
    ],
    front_cancel_within: 0,
    front_cancel_allow: "allowed_days",
    front_cancel_allow_show: false,
  }),
  methods: {
    //맴버십 설정/관리 페이지 이동
    membershipManageMove: function() {
      this.$router.push({
        path: `/membership/${this.$store.state.mallId}/membershipManage`,
      });
    },
    //멤버십 저장
    membershipSettingSave: async function() {
      if (!this.membership_name) {
        alert("멤버십명을 입력해주세요.");
        return false;
      }

      if (this.membership_price <= 0) {
        alert("멤버십 판매가격을 입력해주세요.");
        return false;
      }

      if (!this.benefitPeriodModel) {
        alert("멤버십 혜택 기간을 선택해주세요.");
        return false;
      }

      if (!this.group_no || !this.group_name) {
        alert("멤버십 회원 등급 설정을 확인해주세요.");
        return false;
      }

      if (
        this.use_free_start != "enabled" ||
        this.periodic_payment_model != "enabled"
      ) {
        this.use_free_start = "disabled";
      }

      let use_discount = "F";
      if (this.periodic_payment_model == "enabled") {
        if (this.use_free_term) {
          this.use_free_start = "enabled";
        }
        use_discount = "T";
      }
      let revert_coupon = "disabled";
      if (this.couponReclaimModel == true) {
        revert_coupon = "enabled";
      }

      let revert_point = "disabled";
      if (this.pointReclaimModel == true) {
        revert_point = "enabled";
      }

      // 매칭 해지 분류 리스트 for문
      for (let i = 0; i < this.original_product_list.length; i++) {
        let category_no = this.original_product_list[i].category_no;
        // 처음 조회했을때 저장 되어있던 분류 리스트 였는지 체크
        let index = this.product_list.findIndex(
          (product) => product.category_no == category_no
        );
        // 기존에 저장되었던 분류가 없으면 표시상태, 메인분류 표시상태 미노출
        if (index < 0) {
          let setParams = {
            category_display_status: "disabled",
            category_main_status: "disabled",
          };

          try {
            await M.api(
              M.entry("/put/membership/categories/status", category_no),
              setParams
            );
          } catch (e) {
            //
          }
        }
      }
      this.original_product_list = [];
      for (let j = 0; j < this.product_list.length; j++) {
        this.original_product_list.push(this.product_list[j]);
      }

      if (this.front_cancel_allow != "allowed_days") {
        this.front_cancel_within = 0;
      }

      let setData = {
        membership_name: this.membership_name,
        membership_price: Common.onlyNumber(this.membership_price),
        use_discount: use_discount,
        subscription_shipments_cycle: this.benefitPeriodModel,
        group_no: this.group_no,
        group_name: this.group_name,
        coupon_info: this.coupon_list,
        revert_coupon: revert_coupon,
        point_info: this.point_list,
        revert_point: revert_point,
        category_info: this.product_list,
        use_free_start: this.use_free_start,
        use_free_term: this.use_free_term,
        front_cancel_within: this.front_cancel_within,
        front_cancel_allow: this.front_cancel_allow,
      };

      this.$refs.ProgressDialog.show();

      try {
        await M.api(M.entry("/put/membership", this.membership_id), setData);
        alert("수정되었습니다.");
      } catch (e) {
        alert("수정 실패되었습니다.");
      }
      this.$refs.ProgressDialog.hide();
    },
    //회원등급 조회 / 매칭하기
    memberLeveSearchMatching: function() {
      if (this.group_no) {
        alert(
          "카페24에 설정되어 있는 1개의 회원등급과 매칭이 가능합니다.\n현재 설정되어 있는 회원등급을 매칭 해지 후 사용해주세요."
        );
        return false;
      }
      this.$refs.MemberLevelSearchMatching.show();
    },
    //쿠폰 조회 및 설정 모달
    couponSearchSetting: function() {
      //
      this.$refs.CouponSearchSetting.show();
    },
    //회원 등급 매칭 해지
    memberLevelClose: function() {
      if (
        confirm(
          "매칭 해지를 통해 다른 회원등급으로 변경 또는\n멤버십 혜택을 종료하시는 경우에는\n이미 구매한 멤버십 회원이 있으면\n혜택 부분에 대한 변경사항을\n안내하시길 권장합니다.\n\n멤버십으로 설정하신 해당 회원등급을\n매칭 해지 하시겠습니까?"
        )
      ) {
        this.memberLevelReset();
        alert("매칭이 해지되었습니다.");
      }
    },
    //쿠폰 매칭 해지
    couponMatchingClose: function(coupon_no) {
      if (
        confirm(
          "매칭 해지시 해당 쿠폰은 설정 목록에서 삭제되며\n이미 고객에게 발급된 쿠폰은\n삭제되지 않습니다.\n\n발급된 쿠폰까지 삭제하시는 경우\n[카페24 쿠폰관리>쿠폰발급/조회]메뉴\n에서 완전 삭제 처리가 가능합니다.\n\n해당 쿠폰을 멤버십 매칭 해지 처리하시겠습니까?"
        )
      ) {
        var index = this.coupon_list.findIndex(
          (coupon) => coupon.coupon_no == coupon_no
        );
        this.coupon_list.splice(index, 1);

        alert("매칭이 해지되었습니다.");
      }
    },
    //포인트 세팅 모달
    pointSetting: function() {
      this.$refs.PointSetting.show();
    },
    //포인트 매칭 해지
    pointMatchingClose: function(i) {
      if (
        confirm(
          "매칭 해지시 설정 목록에서 삭제되며\n이미 고객에게 지급된 적립금은\n유지됩니다.\n\n설정하신 멤버십 적립금 설정을\n해지 처리하시겠습니까?"
        )
      ) {
        this.point_list.splice(i, 1);
        alert("매칭이 해지되었습니다.");
      }
    },
    //쿠폰 리스트 제목 클릭
    couponClick: function(coupon_no) {
      window.open(
        // coupon_no -> 쿠폰번호 변경 해야함
        `https://${this.$store.state.mallId}.cafe24.com/disp/admin/newcoupon/onlineview?coupon_no=${coupon_no}`,
        "_blank"
      );
    },
    //상품 분류 조회/매칭 모달
    productSearchMatching: function() {
      this.$refs.ProductSearchMatching.show();
    },
    //상품 리스트 제목 클릭
    productClick: function() {
      window.open(
        // coupon_no -> 쿠폰번호 변경 해야함
        `https://${this.$store.state.mallId}.cafe24.com/disp/admin/shop1/product/categorymanage`,
        "_blank"
      );
    },
    //상품 매칭 해지
    productMatchingClose: function(category_no) {
      if (
        confirm(
          "매칭 해지시 멤버십 설정 목록에서 삭제되며\n쇼핑몰에서 접근할 수 없도록\n미노출되게 변경합니다.\n\n상품 분류를 삭제하시는 경우\n[카페24 상품관리>분류관리]메뉴\n에서 삭제 처리하시길 권장합니다.\n\n설정하신 상품 분류를 매칭 해지하시겠습니까?"
        )
      ) {
        let index = this.product_list.findIndex(
          (product) => product.category_no == category_no
        );

        this.product_list.splice(index, 1);

        alert("매칭이 해지되었습니다.");
      }
    },
    //상품 상세 매칭
    productDetailClick: function(category_no) {
      window.open(
        // coupon_no -> 쿠폰번호 변경 해야함
        `https://${this.$store.state.mallId}.cafe24.com/disp/admin/product/productmanage?category=${category_no}&categorys%5B%5D=${category_no}&bIsSearchClickAction=T`,
        "_blank"
      );
    },
    //설정 조회
    getMembershipConfig: async function() {
      this.one_payment_disabled = false;

      try {
        let result = await M.api(M.entry("/get/membership/config"));

        if (result.use_recurring_payment == "enabled") {
          this.periodic_payment_model = "enabled";
          this.periodic_payment_disabled = false;
        } else {
          this.periodic_payment_model = "disabled";
          this.periodic_payment_disabled = true;
        }
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
    MemberLevelMatching: async function(params) {
      this.group_no = params.group_no;
      this.group_name = params.group_name;

      // 무료배송
      this.ship_benefits = params.ship_benefits;

      //구매할인
      this.discount_information = params.discount_information;

      //모바일 추가 할인
      this.mobile_discount_information = params.mobile_discount_information;

      //구매 적립금 지급
      this.points_information = params.points_information;

      //모바일 추가 적립
      this.mobile_points_information = params.mobile_points_information;
    },
    //회원등급 매칭 리셋
    memberLevelReset: function() {
      this.group_no = "";
      this.group_name = "";
      this.ship_benefits = "";
      this.discount_information = {
        amount_product: "",
        amount_discount: "",
        discount_unit: "",
      };
      this.mobile_discount_information = {
        amount_product: "",
        amount_discount: "",
        discount_unit: "",
      };
      this.points_information = {
        amount_product: "",
        amount_discount: "",
        discount_unit: "",
      };
      this.mobile_points_information = {
        amount_product: "",
        amount_discount: "",
        discount_unit: "",
      };
    },
    //쿠폰 리스트 추가
    addCouponList: function(params) {
      const index = this.coupon_list.findIndex(
        (coupon) => coupon.coupon_no == params.coupon_no && coupon.coupon_issued_type == params.coupon_issued_type
      );
      if (index == -1) {
        this.coupon_list.push(params);
        return true;
      } else {
        return false;
      }
    },
    //적립금 리스트 추가
    addPointList: function(params) {
      this.point_list.push(params);
    },
    //상품분류 리스트 추가
    addProductList: function(params) {
      var index = this.product_list.findIndex(
        (category) => category.category_no == params.category_no
      );
      if (index == -1) {
        this.product_list.push(params);
        return true;
      } else {
        return false;
      }
    },
    //멤버십 조회
    getMembershipInfo: async function() {
      try {
        let result = await M.api(
          M.entry("/get/membership", this.membership_id)
        );

        //멤버십명
        this.membership_name = result.membership_name;
        //멤버십 판매가격
        this.membership_price = Common.comma(result.membership_price);

        //멤버십 혜택 기간
        this.benefitPeriodModel = result.subscription_shipments_cycle;

        //멤버십 회원등급 설정
        this.group_no = result.group_no;
        this.group_name = result.group_name;

        //무료배송
        this.ship_benefits = result.ship_benefits;

        //구매할인
        this.discount_information = result.discount_information;

        //모바일 추가 할인
        this.mobile_discount_information = result.mobile_discount_information;

        //구매 적립금 지급
        this.points_information = result.points_information;

        //모바일 추가 적립
        this.mobile_points_information = result.mobile_points_information;

        //쿠폰 지급
        this.coupon_list = [];
        for (const coupon of result.coupon_info) {
          if (this.coupon_info_list[coupon.coupon_no]) {
            this.coupon_list.push(coupon);
          }
        }

        this.use_free_start = result.use_free_start;
        this.front_cancel_within = result.front_cancel_within;
        this.front_cancel_allow = "allowed_days";
        if (result.use_free_start == "disabled") {
          this.use_free_term = "";
        } else {
          this.use_free_term = result.use_free_term;
        }

        //쿠폰 회수 사용 여부
        if (result.revert_coupon == "enabled") {
          this.couponReclaimModel = true;
        } else {
          this.couponReclaimModel = false;
        }

        //적립금 지급
        this.point_list = result.point_info;

        //적립금 회수 여부 상태
        this.point_recovery_status = result.point_recovery_status;

        //결제 설정
        this.periodic_payment_model = "disabled";
        if (result.use_discount == "T") {
          this.periodic_payment_model = "enabled";
        }

        if (result.number_of_members > 0) {
          this.one_payment_disabled = true;
          this.periodic_payment_disabled = true;
        }

        /**
         * 멤버십전용 상품
         * 삭제 된 멤버십 거르기
         */
        for (let i = 0; i < result.category_info.length; i++) {
          if (this.product_info_list[result.category_info[i].category_no]) {
            this.product_list.push(result.category_info[i]);
            this.original_product_list.push(result.category_info[i]);
          }
        }
      } catch (e) {
        if (e.response.data.message == "not found product") {
          alert("카페24 어드민에서 삭제된 상품입니다.");
          this.$router.push({
            path: `/membership/${this.$store.state.mallId}/membershipManage`,
          });
        } else {
          alert("새로고침(F5)하여 재확인해주세요.");
        }
      }
    },
    getCoupons: async function() {
      try {
        let result = await M.api(M.entry("/get/membership/coupons"));
        for (let i = 0; i < result.length; i++) {
          this.coupon_info_list[result[i].coupon_no] = result[i].coupon_name;
        }
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },

    getCoupon: async function(params) {
      try {
        return await M.api(M.entry("/get/membership/coupon"), params);
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
    getCategories: async function() {
      try {
        let result = await M.api(M.entry("/get/membership/categories"));
        for (let i = 0; i < result.length; i++) {
          this.product_info_list[result[i].category_no] =
            result[i].category_name;
        }
      } catch (e) {
        alert("새로고침(F5)하여 재확인해주세요.");
      }
    },
    //등급 상세 조회
    searchDetailLevel: async function() {
      let result = {};
      try {
        result = await M.api(
          M.entry("/get/membership/groups/detail", this.group_no)
        );

        this.group_name = result.group_name;

        //무료배송
        this.ship_benefits = result.ship_benefits;

        //구매할인
        this.discount_information = result.discount_information;

        //모바일 추가 할인
        this.mobile_discount_information = result.mobile_discount_information;

        //구매 적립금 지급
        this.points_information = result.points_information;

        //모바일 추가 적립
        this.mobile_points_information = result.mobile_points_information;
      } catch (e) {
        alert("조회되지 않았습니다.");
      }
      return result;
    },
    userMemebershipCancelChange: function() {
      if (this.front_cancel_allow == "allowed_days") {
        // this.front_cancel_allow_show = true;
      } else {
        // this.front_cancel_allow_show = false;
      }
      this.front_cancel_within = 0;
    },
    useFreeStartChange: function() {
      if (this.use_free_term == "") {
        this.use_free_start = "disabled";
      } else {
        this.use_free_start = "enabled";
      }
    },
    sleep: async function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
  },
  mixins: [CommonMixin],
  filters: Filters,
  components: {
    MemberLevelSearchMatching,
    CouponSearchSetting,
    PointSetting,
    ProductSearchMatching,
    ProgressDialog,
  },
  beforeCreate: function() {
    this.$parent.$parent.progressShow();
  },
  created: async function() {
    //mall_id
    this.mall_id = this.$store.state.mallId;
    //멤버십 아이디
    this.membership_id = this.$route.query.membership_id;

    await this.getMembershipConfig();
    await this.getCategories();
    await this.getCoupons();
    await this.getMembershipInfo();
    await this.searchDetailLevel();

    this.cafe24_group_url = `https://${this.$store.state.mallId}.cafe24.com/admin/php/shop1/c/member_admin_c_f.php`;
    this.cafe24_coupon_url = `https://${this.$store.state.mallId}.cafe24.com/disp/admin/shop1/Newcoupon/onlineCreate`;
    this.cafe24_category_url = `https://${this.$store.state.mallId}.cafe24.com/disp/admin/shop1/product/categorymanage`;
    this.cafe24_product_url = `https://${this.$store.state.mallId}.cafe24.com/disp/admin/shop1/product/productregister`;

    this.$parent.$parent.progressHide();
  },
  watch: {
    periodic_payment_model: function(new_param) {
      if (new_param == "enabled") {
        this.use_free_term_disabled = false;
      } else {
        this.use_free_term_disabled = true;
      }
    },
  },
};
</script>

